const siteUrl = 'https://www.latori.com';

const toSitemapLastMod = (...values) => {
  for (const value of values) {
    if (!value) {
      continue;
    }

    const normalizedValue = Array.isArray(value) ? value[0] : value;
    const date = new Date(normalizedValue);

    if (!Number.isNaN(date.getTime())) {
      return date.toISOString();
    }
  }

  return null;
};

const normalizeSitemapPath = (value) => {
  if (!value || value === '/') {
    return '/';
  }

  const withLeadingSlash = value.startsWith('/') ? value : `/${value}`;

  if (withLeadingSlash.endsWith('/')) {
    return withLeadingSlash.slice(0, -1);
  }

  return withLeadingSlash;
};

const addPathVariants = (map, path, node) => {
  const normalizedPath = normalizeSitemapPath(path);
  const nextMap = {
    ...map,
    [normalizedPath]: node,
  };

  if (normalizedPath !== '/') {
    return {
      ...nextMap,
      [`${normalizedPath}/`]: node,
    };
  }

  return nextMap;
};

const sitemapExcludedPaths = new Set([
  '/404',
  '/en/404',
  '/editor-storyblok',
  '/test-page',
  '/en/test-page',
  '/partners/test',
  '/en/partners/test',
  '/references/example',
  '/en/references/example',
  '/products/example-story',
  '/en/products/example-story',
  '/success',
  '/en/success',
  '/en/blog/buchhaltung-payment',
  // Duplicate blog category URLs: the same category is also built under its other slug.
  '/blog/ecommerce',
  '/blog/accounting-payment',
  '/en/blog/ecommerce',
  '/en/blogpost/latori-review-2029',
  // Job postings that should not be indexed.
  '/jobs/backend-entwickler-programmierer-w-m-d',
  '/en/jobs/backend-developer-programmer-w-m-d',
  '/jobs/assistenz-der-geschaeftsfuehrung-m-w-d-teilzeit-oder-vollzeit',
  '/en/jobs/assistenz-der-geschaeftsfuehrung-m-w-d-teilzeit-oder-vollzeit',
  '/jobs/technical-sales-consultant-fur-shopify-stores',
  '/en/jobs/technical-sales-consultant-for-shopify-stores',
  '/jobs/werkstudent-frontend-backend-entwickler-programmierer-w-m-d',
  '/en/jobs/working-student-frontend-backend-developer-programmer-f-m-d',
  '/jobs/frontend-entwickler-programmierer-w-m-d',
  '/en/jobs/frontend-developer-programmer-w-m-d',
  '/jobs/customer-support-w-m-d-vollzeit-oder-teilzeit',
  '/en/jobs/customer-support-w-m-d-vollzeit-oder-teilzeit',
  '/jobs/technical-sales-representative-shopify-specialist-m-w-d',
  '/en/jobs/technical-sales-representative-shopify-specialist-m-w-d',
  '/jobs/projektmanager-m-w-d',
  '/en/jobs/projektmanager-m-w-d',
  '/jobs/auszubildender-fachinformatiker-fuer-anwendungsentwicklung',
  '/en/jobs/apprentice-it-specialist-for-application-development',
]);

// eslint-disable-next-line global-require
const redirectFromPaths = new Set(
  require('./redirects.json').map((redirect) => normalizeSitemapPath(redirect.fromPath)),
);

const isTestPath = (value) => /\/test$/.test(normalizeSitemapPath(value));

const isSitemapPathExcluded = (value) => {
  const normalizedPath = normalizeSitemapPath(value);
  return sitemapExcludedPaths.has(normalizedPath)
    || redirectFromPaths.has(normalizedPath)
    || isTestPath(normalizedPath);
};

const normalizeStoryblokPath = (fullSlug) => {
  if (!fullSlug || fullSlug === 'home') {
    return '/';
  }

  const localeHomeMatch = fullSlug.match(/^([a-z]{2})\/home$/i);
  if (localeHomeMatch) {
    return `/${localeHomeMatch[1].toLowerCase()}`;
  }

  return `/${fullSlug}`;
};

module.exports = {
  trailingSlash: 'never',
  siteMetadata: {
    title: 'Latori GmbH',
    description: '✅ Wir waren die erste Shopify Agentur für Shopify Plus in Deutschland! Ihr Shopify Partner für ✓ Shop-Erstellung ✓ Migration ✓ Programmierung ✓ Design.',
    siteUrl,
    author: {
      name: 'Latori GmbH',
    },
    social: {
      twitter: 'latori-gmbh',
    },
    intro: {
      title: 'Über uns',
      text: 'Wir, das Team der Latori GmbH, sind eine spezialisierte Shopify Agentur mit Sitz in Wuppertal und Stuttgart. Als Experten für individuelle Softwareentwicklung, Design, Shop-Setup und Migration betreuen wir komplexe Projekte mit Fokus auf Shopify und Shopify Plus. Namhafte E-Commerce-Unternehmen wie Sennheiser, Mister Spex oder Live Fast Die Young vertrauen auf unsere über 10-jährige Erfahrung in der Entwicklung und Optimierung. Unser Ziel als Ihre Shopify Agentur: den E-Commerce für Sie so einfach wie möglich zu machen und Ihren Alltag mit unseren zukunftssicheren Lösungen zu erleichtern. Wir sind bereit für Ihre Herausforderungen.',
      claim: 'simply. better. commerce.',
      link: {
        url: '/',
        label: 'Mehr',
      },
    },
    textImageScrollSlider: [
      {
        title: 'Darauf sind wir stolz',
        subTitle: 'Shop Usability Award: AGENTUR DES JAHRES 2023!',
        description: 'Wir sind übermäßig stolz und dankbar, dass wir zur Agentur des Jahres 2023 gekürt wurden. Ein großes Dankeschön geht an die K5, den Shop Usability Award aber vor allem an das gesamte Latori-Team aus Shopify Experten für diese herausragende Leistung. 🥳',
        link: {
          url: '/blogpost/shop-usability-award',
          text: 'Mehr erfahren',
        },
      },
      {
        title: '',
        subTitle: 'SHOP USABILITY AWARD: ASPHALTGOLD GEWINNT DEN SUA!',
        description: 'Der Shopify Onlineshop der Streetwear- und Lifestyle-Brand Asphaltgold konnte sich den Sieg in der Kategorie Fashion & Accessoires sichern. 🎉',
        link: {
          url: '',
          text: '',
        },
      },
      {
        title: '',
        subTitle: 'SHOP USABILITY AWARD: LATORI-KUNDE SENNHEISER RÄUMT AB!',
        description: 'Sennheiser stellte sich der Konkurrenz in der Kategorie Electronics & Entertainment - mit Erfolg! 🏆',
        link: {
          url: '',
          text: '',
        },
      },
      {
        title: '',
        subTitle: 'Shop Usability Award: SHEKO SETZT SICH DURCH!',
        description: 'Auch SHEKO lässt die Konkurrenz hinter sich und holt sich den 1. Platz in der Kategorie FCMG. 🥇',
        link: {
          url: '',
          text: '',
        },
      },
    ],
    seoTextSection: {
      title: 'Warum wir auf Shopify setzen',
      subtitle: 'Unser System des Vertrauens für individuelle D2C und B2B Projekte',
      texts: [
        'Als zertifizierte Shopify Agentur brennen wir für dieses Shopsystem. Warum? Die cloudbasierte All-in-One-Lösung will den Handel für jedes Unternehmen besser machen. Dieses Versprechen wird durch ein intuitives, flexibles und verlässliches System mit zahlreichen Schnittstellen erfüllt. Unternehmen profitieren beim Einsatz der Software-as-a-Service-Lösung von vielen Vorteilen: Wer Shopify oder Shopify Plus im Einsatz hat, muss zukünftig keine Systemwechsel, kostspieligen Updates oder Backups mehr befürchten. Das macht das System automatisch. Auch das Hosting wird übernommen. Darüber hinaus bietet Shopify integrierte Marketingtools, um den Umsatz zu steigern und Kunden zu binden. Mit einer sicheren und zuverlässigen Infrastruktur können Marken außerdem auf ein skalierbares System zugreifen, das mit ihrem Wachstum mitwächst.',
        'Die Plattform bietet Marken jeder Größe eine selbsterklärende Usability, vorgefertigte Themes, eine Vielzahl von Designs und einen umfangreichen App Store, für den individuellen Aufbau Ihres eigenen Onlineshops. Setzen Sie Ihr Produkt in einem professionellen Onlineshop in Szene - Shopify bietet die perfekte Basis dafür.',
        'Wenn es dann doch noch etwas individueller sein darf, gibt es Latori - eine von wenigen spezialisierten Shopify Agenturen in Deutschland. Wir realisieren auf unserer Seite die Erstellung Ihres Shops, kümmern uns um zusätzliche Entwicklungen Ihrer Onlineshop-Wünsche, nehmen die Umsetzung eines responsiven und verkaufsstarken Designs in die Hand und unterstützen Sie bei der Konzeption und Optimierung Ihres Onlinestores. Dabei setzen wir auch auf die Zusammenarbeit mit starken Partnern, die für Ihre Marke Marketing- und Optimierungs-Services anbieten. So wird Ihr Projekt auch zu unserem.',
        'Beinahe 3 Millionen Händler auf der ganzen Welt setzen mittlerweile auf die Lösung, darunter sowohl zahlreiche etablierte Marken wie Sennheiser, Vogue oder Babbel als auch junge D2C-Marken wie ooia, Asphaltgold oder Live Fast Die Young. Als Shopify Experten betreuen wir genau die Onlineshops dieser Marken.',
        'Dass wir als Shopify Agentur eine gute Wahl sind, beweisen auch unsere Auszeichnungen. Im Jahr 2023 wurden wir als Agentur des Jahres beim Shop Usability Award ausgezeichnet, zudem erhielten auch drei unserer Kunden diese begehrte Auszeichnung für ihren Shop.',
        'Konzentrieren Sie sich auf das, was Sie am besten können: Erstklassige Produkte zu erstellen und zu vertreiben. Um den Rest kümmern wir uns als zertifizierte Shopify Agentur gern für Sie!',
      ],
    },
    footer: {
      menuLinks: [
        {
          title: 'Social',
          links: [
            {
              name: 'Linkedin',
              link: 'https://www.linkedin.com/company/latori/',
              icon: 'linkedin-in',
            },
            {
              name: 'Instagram',
              link: 'https://www.instagram.com/latori_gmbh/',
              icon: 'instagram',
            },
          ],
        }, {
          title: 'Legal',
          links: [
            {
              name: 'Impressum',
              link: '/imprint',
            },
            {
              name: 'Datenschutz',
              link: '/privacy',
            },
            {
              name: 'Cookie-Einstellungen',
              link: '#cookie-banner',
            },
          ],
        },
        {
          title: 'Locations',
          links: [
            {
              name: 'Wuppertal',
              link: '/wuppertal',
            },
            {
              name: 'Stuttgart & Umgebung',
              link: '/stuttgart',
            },
          ],
        },
      ],
      additionalText: 'Wir schätzen alle unsere Kunden, Nutzer und Leser, egal ob weiblich, männlich, divers oder nicht-binär. Der Lesbarkeit halber verzichten wir auf Gendersternchen und nutzen weiterhin das generische Maskulinum. Wir sprechen damit ausdrücklich alle an. Bitte beachten Sie außerdem, dass wir Zitate zum besseren, sprachlichen Verständnis leicht angepasst haben.',
    },
    consent: {
      title: 'Privatsphäre-Einstellungen',
      description: 'Diese Seite nutzt Website-Tracking-Technologien von Dritten, um ihre Dienste anzubieten, stetig zu verbessern und Werbung entsprechend der Nutzer anzuzeigen. Sie können unsere Seite grundsätzlich auch ohne das Setzen von Cookies besuchen und Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen oder ändern.',
      imprint: 'Impressum',
      privacy: 'Datenschutzerklärung',
    },
  },
  plugins: [
    'gatsby-transformer-yaml',
    'gatsby-plugin-react-helmet',
    'gatsby-transformer-sharp',
    {
      resolve: 'gatsby-plugin-gatsby-cloud',
      options: {
        headers: {
          '/*': [
            'X-Frame-Options: SAMEORIGIN',
          ],
          '/_gatsby/*': [
            'Cache-Control: public, max-age=31536000, immutable',
          ],
          '/page-data/*': [
            'Cache-Control: public, max-age=2592000, stale-while-revalidate=86400',
          ],
          '/*.js': [
            'Cache-Control: public, max-age=31536000, immutable',
          ],
          '/*.css': [
            'Cache-Control: public, max-age=31536000, immutable',
          ],
          '/static/*': [
            'Cache-Control: public, max-age=31536000, immutable',
          ],
          '/assets/*': [
            'Cache-Control: public, max-age=31536000, immutable',
          ],
          '/icons/*': [
            'Cache-Control: public, max-age=31536000, immutable',
          ],
          '/favicon*': [
            'Cache-Control: public, max-age=31536000, immutable',
          ],
          '/manifest.webmanifest': [
            'Cache-Control: public, max-age=2592000, stale-while-revalidate=86400',
          ],
          '/*': [
            'X-Frame-Options: SAMEORIGIN',
            'X-Robots-Tag: index, follow',
            'Cache-Control: public, max-age=0, must-revalidate',
          ],
        },
      },
    },
    {
      resolve: 'gatsby-plugin-sharp',
      options: {
        // Defaults used for gatsbyImageData and StaticImage
        defaults: {},
        // Relates to "options.failOn" in https://sharp.pixelplumbing.com/api-constructor#parameters
        failOn: 'warning',
      },
    },
    {
      resolve: 'gatsby-plugin-layout',
      options: {
        component: require.resolve('./src/components/layout.js'),
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        path: `${__dirname}/content/blog`,
        name: 'blog',
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        path: `${__dirname}/content/data/`,
        name: 'data',
      },
    },
    {
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://www.latori.com',
        sitemap: 'https://www.latori.com/sitemap-index.xml',
        policy: [{
          userAgent: '*',
          allow: '/',
          disallow: '/cdn-cgi/l/email-protection',
        }],
      },
    },
    {
      resolve: 'gatsby-plugin-sitemap',
      options: {
        output: '/',
        query: `
          {
            allSitePage {
              nodes {
                path
              }
            }
            allMarkdownRemark(
              filter: { fileAbsolutePath: { regex: "/(blog)/" }}
              sort: { fields: [frontmatter___date], order: ASC }
              limit: 1000
            ) {
              nodes {
                id
                frontmatter {
                  permalink
                  date
                }
              }
            }
            allStoryblokEntry {
              nodes {
                full_slug
                first_published_at
                published_at
                updated_at
                created_at
              }
            }
          }
        `,
        resolveSiteUrl: () => siteUrl,
        resolvePages: ({
          allSitePage: { nodes: allPages },
          allMarkdownRemark: { nodes: allMarkdownNodes },
          allStoryblokEntry: { nodes: allStoryblokNodes },
        }) => {
          const markdownNodeMap = allMarkdownNodes.reduce((acc, node) => {
            const permalink = node.frontmatter?.permalink;

            if (!permalink) {
              return acc;
            }

            return addPathVariants(acc, permalink, node);
          }, {});

          const storyblokNodeMap = allStoryblokNodes.reduce((acc, node) => {
            const normalizedPath = normalizeStoryblokPath(node.full_slug);
            return addPathVariants(acc, normalizedPath, node);
          }, {});

          return allPages
            .filter((page) => !isSitemapPathExcluded(page.path))
            .map((page) => {
              const normalizedPagePath = normalizeSitemapPath(page.path);

              return {
                ...page,
                ...storyblokNodeMap[normalizedPagePath],
                ...markdownNodeMap[normalizedPagePath],
              };
            });
        },
        serialize: ({
          path,
          frontmatter,
          first_published_at,
          published_at,
          updated_at,
          created_at,
          lastmod,
        }) => {
          const resolvedLastMod = toSitemapLastMod(
            lastmod,
            frontmatter?.lastmod,
            updated_at,
            published_at,
            frontmatter?.date,
            first_published_at,
            published_at,
            updated_at,
            created_at,
          );

          return resolvedLastMod
            ? {
              url: path,
              lastmod: resolvedLastMod,
            }
            : {
              url: path,
            };
        },
        excludes: [
          '/**/icons/*', '/icons', 'icons', // excludes any route that matches /icons/*, /en/icons/*, /fr/icons/*, etc.
          '/**/test', '/test', // excludes any route ending in /test
          '/blog/page/*', '/blog/*/page/*', '/en/blog/page/*', '/en/blog/*/page/*', // excludes paginated blog pages
          '/404', '/en/404',
          '/editor-storyblok',
          '/test-page', '/en/test-page',
          '/partners/test', '/en/partners/test',
          '/references/example', '/en/references/example',
          '/products/example-story', '/en/products/example-story',
          '/success', '/en/success',
          '/en/blog/buchhaltung-payment',
          '/blog/ecommerce', '/blog/accounting-payment', '/en/blog/ecommerce',
          '/en/blogpost/latori-review-2029',
        ],
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'images',
        path: `${__dirname}/src/images`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'fonts',
        path: `${__dirname}/src/fonts`,
      },
    },
    {
      resolve: 'gatsby-transformer-remark',
      options: {
        plugins: [
          {
            resolve: 'gatsby-remark-images',
            options: {
              maxWidth: 630,
            },
          },
          {
            resolve: 'gatsby-remark-responsive-iframe',
            options: {
              wrapperStyle: 'margin-bottom: 1.0725rem',
            },
          },
          'gatsby-remark-autolink-headers',
          'gatsby-remark-prismjs',
          'gatsby-remark-copy-linked-files',
          'gatsby-remark-smartypants',
        ],
      },
    },
    {
      resolve: 'gatsby-plugin-react-svg',
      options: {
        rule: {
          include: /assets/,
        },
      },
    },
    'gatsby-plugin-postcss',
    'gatsby-plugin-image',
    {
      resolve: 'gatsby-plugin-gdpr-cookies',
      options: {
        googleAnalytics: {
          trackingId: 'G-WF2DPMKGWD',
          anonymize: true,
        },
        klaviyo: {
          cookieName: 'gatsby-gdpr-klaviyo',
          trackingId: 'UjZT3H',
        },
        provenExpert: {
          cookieName: 'gatsby-gdpr-proven-expert',
          url: 'https://www.provenexpert.com/widget/bar_latori-gmbh.js',
        },
        linkedin: {
          cookieName: 'gatsby-gdpr-linked-in',
          trackingId: '2098914',
        },
        facebookPixel: {
          cookieName: 'gatsby-gdpr-facebook-pixel',
          pixelId: '161569961359773',
        },
        inspectlet: {
          cookieName: 'gatsby-gdpr-inspectlet-pixel',
          pixelId: '1522785580',
        },
        // Defines the environments where
        // the tracking should be available  - default is ["production"]
        environments: ['production'],
      },
    },
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        icon: 'src/assets/logo-square.svg',
      },
    },
    {
      resolve: 'gatsby-source-personio-xml',
      options: {
        url: 'https://latori.jobs.personio.de/xml?language=de',
      },
    },
    {
      resolve: 'gatsby-source-storyblok',
      options: {
        accessToken: process.env.STORYBLOK_ACCESS_TOKEN,
        components: {
          germany_map: 'storyblok/maps',
        },
        cache: {
          clear: 'auto',
          type: 'memory',
        },
        resolveRelations: [
          'blogpost.author',
          'blogpost.reviewer',
          'page.jobs',
          'job-positions.jobs',
          // 'references-tiles.tile',
          'use-cases-tiles.use_case',
          'services-tiles.services',
          'service.icon',
          'navigation.Menu',
          'page.Icon',
          'blogpost-tiles-section.blogposts',
          'Perks.perks',
          'Perk.icon',
          'Perk.new_icon',
        ],
        // Production builds only get published content. Set STORYBLOK_VERSION=draft on a
        // preview/staging build to include unpublished drafts.
        version: process.env.STORYBLOK_VERSION
          || (process.env.NODE_ENV === 'production' ? 'published' : 'draft'),
        previewToken: process.env.STORYBLOK_PREVIEW_TOKEN,
        // Optional parameter to download the images to use with Gatsby Image Plugin
        localAssets: false,
        languages: ['default', 'en'],
        // defaultLanguage: 'default',
        // Optional parameter. Omission will retrieve all languages by default.
        resolveLinks: 'story',
      },
    },
    {
      resolve: 'gatsby-plugin-local-search',
      options: {
        name: 'blog',
        engine: 'flexsearch',
        query: `
          {
            allStoryblokEntry(
              filter: {
                field_component: { eq: "blogpost" }
                lang: { eq: "default" }
              }
              sort: { first_published_at: DESC }
            ) {
              edges {
                node {
                  name
                  full_slug
                  slug
                  field_title_string
                }
              }
            }
          }
        `,
        ref: 'slug',
        index: ['title'],
        store: ['title', 'slug', 'name', 'full_slug'],
        normalizer: ({ data }) => data.allStoryblokEntry.edges
          .map(({ node }) => ({
            ...node,
            title: node.field_title_string || node.name || node.slug,
          })),
      },
    },
  ],
  flags: {
    PARALLEL_QUERY_RUNNING: true,
    PARALLEL_SOURCING: true,
    DEV_SSR: false,
    FAST_DEV: false,
    PRESERVE_FILE_DOWNLOAD_CACHE: true,
    PRESERVE_WEBPACK_CACHE: true,
  },
};
